module.exports = __webpack_public_path__ + "87ee601a15d62c0285e5f30c12b03a85.svg";


//////////////////
// WEBPACK FOOTER
// ./directives/navbar/main_logo.svg
// module id = 244
// module chunks = 0